export const RiskAssessmentFactory = (data) => {
    return {
      pep: data.pep || "",
      pepOwner: data.pepOwner || "",
      sanctionedPerson: data.sanctionedPerson || "",
      understandClientBussiness: data.understandClientBussiness || "",
      understandClientBussinessExplanation: data.understandClientBussinessExplanation || "",
      particularTransaction: data.particularTransaction || "",
      particularTransactionExplanation: data.particularTransactionExplanation || "",
      terroristFinancing: data.terroristFinancing || data.TerroristFinancing || "",
      sectorFromDropdown: data.sectorFromDropdown || "",
      cashIntensive: data.cashIntensive || "",
      cashIntensiveBusinessName: data.cashIntensiveBusinessName || "",
      otherCashIntensiveBusinessName: data.otherCashIntensiveBusinessName || "",
      financialCrime: data.financialCrime || data.FinancialCrime || "",
      pepEvasive: data.pepEvasive || "",
      transactionCompletedWithUndueSpeed: data.transactionCompletedWithUndueSpeed || data.TransactionCompletedWithUndueSpeed || "",
      adverseSearch: data.adverseSearch || "",
      adversePublicity: data.adversePublicity || "",
      adverseInformation: data.adverseInformation || "",
      criminalProceedings: data.criminalProceedings || "",
      taxInvasionIndication: data.taxInvasionIndication || data.TaxInvasionIndication || "",
      InfluenceTransaction: data.InfluenceTransaction || "",
      IntermediaryName: data.IntermediaryName || "",
      IntermediaryRole: data.IntermediaryRole || "",
      status: data.status || "Not Validated"
    };
  };
  